// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"89cfc854","498":"12038cdc","513":"c878b54b"}[chunkId] + ".chunk.js";
};